<template>
  <div @click="onClickCopy">
    <IconV2
      class="pointer"
      style="z-index: 999"
      name="v2-copy"
      :color="color"></IconV2>
  </div>
</template>


<script>
export default {
  name: "ButtonCopy",
  props: ["valueCopy", "color"],
  methods: {
    onClickCopy() {
      const el = document.createElement("textarea");
      el.value = this.valueCopy;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
  },
};
</script>

<style></style>